import React, { Component } from 'react';
import './App.css';
import HeroHeader from './static/HeroHeader';
import RhawHeader from './static/RhawHeader'
import Footer from './static/Footer';
import NavMenu from './NavMenu'
import GeneralStyles from './styles/GeneralStyles'
import { Switch, Route } from "react-router-dom";

import PlatformsBox from './SkillsAndExperience/PlatformsBox';
import ContactForm from './ContactMe/ContactForm';
import MyApps from './Apps/MyApps';
import Resume from './ResumeAndDocs/Resume';
import ProjectHistory from './ProjectHistory/ProjectHistory';
import Home from './Home';

import SoftwareDevelopmentService from './Services/SoftwareDevelopmentService';
import ProjectManagementService from './Services/ProjectManagementServices';
import ProjectRescueService from './Services/ProjectRescueServices';
import FullListOfServices from './Services/FullListOfServices';

import MobilePlatform from './Platforms/MobilePlatform';

import AndroidPlatform from './Platforms/AndroidPlatform';
import IOSPlatform from './Platforms/IOSPlatform';
import MobileHybridPlatform from './Platforms/MobileHybridPlatform';
import ServerCloudPlatform from './Platforms/ServerCloudPlatform';
import DesktopPlatform from './Platforms/DesktopPlatform';
import WebPlatform from './Platforms/WebPlatform';
import EmbeddedIoTPlatform from './Platforms/EmbeddedIoTPlatform';

import ConsumerIndustry from './Industries/ConsumerIndustry';
import AviationAerospaceMarineIndustry from './Industries/AviationAerospaceMarineIndustry';
import DHSDODIndustry from './Industries/DHSDODIndustry';
import MedicalMedicalDevicesIndustry from './Industries/MedicalMedicalDevicesIndustry';
import FinancialInsuranceIndustry from './Industries/FinancialInsuranceIndustry';
import NavigationMappingGPSIndustry from './Industries/NavigationMappingGPSIndustry';
import IoTIndustry from './Industries/IoTIndustry';
import FullListOfIndustries from './Industries/FullListOfIndustries';

import AndroidApps from './Apps/AndroidApps';
import IOSApps from './Apps/IOSApps';
import OtherApps from './Apps/OtherApps';

import EquipmentResources from './Resources/EquipmentResources';
import SubscriptionResources from './Resources/SubscriptionResources';
import Privacy from "./Privacy/Privacy";
import TandC from "./Privacy/TandC";



class AppIndexPage extends Component {

    constructor(props) {
        super();

        this.styler = new GeneralStyles();
    }

    render() {

        return (
            <div style={this.styler.currStyles.AppContent}>
                {/*<HeroHeader/>*/}
                <RhawHeader style={this.styler.currStyles.IdBanner}/>
                <NavMenu/>
                <Switch>
                    <Route exact path='/' component={Home}/>
                    <Route exact path='/privacypolicy' component={Privacy}/>
                    <Route exact path='/termsandconditions' component={TandC}/>
                    <Route exact path='/skillsandexperience' component={PlatformsBox}/>
                    <Route exact path='/resume' component={Resume}/>
                    <Route exact path='/projecthistory' component={ProjectHistory}/>
                    <Route exact path='/myapps' component={MyApps}/>
                    <Route exact path='/contact' component={ContactForm}/>

                    <Route exact path='/services/softwaredevelopment' component={SoftwareDevelopmentService}/>
                    <Route exact path='/services/projectmanagement' component={ProjectManagementService}/>
                    <Route exact path='/services/projectrescue' component={ProjectRescueService}/>
                    <Route exact path='/services/fulllist' component={FullListOfServices}/>

                    <Route exact path='/platforms/mobile' component={MobilePlatform}/>

                    <Route exact path='/platforms/android' component={AndroidPlatform}/>
                    <Route exact path='/platforms/ios' component={IOSPlatform}/>
                    <Route exact path='/platforms/mobilehybrid' component={MobileHybridPlatform}/>
                    <Route exact path='/platforms/servercloud' component={ServerCloudPlatform}/>
                    <Route exact path='/platforms/desktop' component={DesktopPlatform}/>
                    <Route exact path='/platforms/web' component={WebPlatform}/>
                    <Route exact path='/platforms/embeddediot' component={EmbeddedIoTPlatform}/>

                    <Route exact path='/industries/consumer' component={ConsumerIndustry}/>
                    <Route exact path='/industries/aerospace_marine' component={AviationAerospaceMarineIndustry}/>
                    <Route exact path='/industries/defense_homeland_security' component={DHSDODIndustry}/>
                    <Route exact path='/industries/medical' component={MedicalMedicalDevicesIndustry}/>
                    <Route exact path='/industries/finance_insur' component={FinancialInsuranceIndustry}/>
                    <Route exact path='/industries/nav_map_gps' component={NavigationMappingGPSIndustry}/>
                    <Route exact path='/industries/iot' component={IoTIndustry}/>
                    <Route exact path='/industries/full_list' component={FullListOfIndustries}/>

                    <Route exact path='/downloads/resume' component={Resume}/>
                    <Route exact path='/downloads/projhistory' component={ProjectHistory}/>

                    <Route exact path='/myapps/android' component={AndroidApps}/>
                    <Route exact path='/myapps/ios' component={IOSApps}/>
                    <Route exact path='/myapps/other' component={OtherApps}/>

                    <Route exact path='/resources/equipment' component={EquipmentResources}/>
                    <Route exact path='/resources/subscriptions' component={SubscriptionResources}/>

                </Switch>
                <Footer/>
            </div>
        );
    }
}

export default AppIndexPage;



// WEBPACK FOOTER //
// src/AppIndexPage.js